module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110261-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110261-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("Abbreviations Used in the Notes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110261-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "txx"
    }
  }, [_c('caption'), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Abbots.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Abbotsford Collection, Nat. Lib. Scot., MSS 1552–4.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("A. L. C.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. G. Cochrane, "), _c('i', [_vm._v("Abbotsford Library")]), _vm._v(" "), _c('i', [_vm._v("Catalogue")]), _vm._v(", 1838.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Bannatyne Club Minutes")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 2046.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Bell’s Dictionary and Digest ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Bell’s Dictionary and Digest of the Law")]), _vm._v(" "), _c('i', [_vm._v("of Scotland")]), _vm._v(", ed. George Watson, 1882.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Blair-Adam Estate")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("William Adam, Blair-Adam Estate, 1834.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cadell Letters")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 1758 (vol. v of letters written by Scott to Cadell).")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cadell’s Diary")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 5188.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("C")]), _c('i', [_vm._v("entenary Catalogue ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Scott Centenary Exhibition Cata")]), _c('i', [_vm._v("logue")]), _vm._v(", 1872.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Charles Scott’s Journal")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Journal of Charles Scott, Nat. Lib. Scot., MS. 1614.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cockburn’s "), _c('i', [_vm._v("Memorials")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memorials of his Time")]), _vm._v(", Henry Cockburn, 1856.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cole’s ‘Memorial of a Tour’")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Owen Blayney Cole, ‘Memorial of a Tour to Italy’, Cornhill Magazine, September 1923.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Croker Papers ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Correspondence and Diaries of J.")]), _vm._v(" "), _c('i', [_vm._v("W. Croker")]), _vm._v(", ed. L. J. Jennings, 1885.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Dalgleish i, ii, iii.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("‘Memoirs of William Dalgleish, Butler to Sir Walter Scott’, "), _c('i', [_vm._v("Cornhill Ma")]), _c('i', [_vm._v("gazine")]), _vm._v(", June, July, and August 1931.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row14"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Diaries of Helen Graham ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", ed. James Irvine, 1956.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row15"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Dibdin")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. C. Dibdin, "), _c('i', [_vm._v("Annals of the Edinburgh")]), _vm._v(" "), _c('i', [_vm._v("Stage")]), _vm._v(", 1888.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row16"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Disc. i and ii")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Discarded letters of Scott, collected by Grierson (but not printed in the "), _c('i', [_vm._v("Letters")]), _vm._v("), Nat. Lib. Scot., MSS. 1752–3.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row17"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("D. N. B.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Dictionary of National Biography")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row18"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Douglas")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Journal of Sir Walter Scott")]), _vm._v(", ed. David Douglas, new edition, 1927.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row19"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Edgar Johnson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Edgar Johnson’s "), _c('i', [_vm._v("Sir Walter Scott:")]), _vm._v(" "), _c('i', [_vm._v("The Great Unknown")]), _vm._v(", 1970.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row20"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Gell")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Reminiscences of Sir Walter Scott’s Residence in Italy")]), _vm._v(", 1832, "), _c('i', [_vm._v("by Sir William")]), _vm._v(" "), _c('i', [_vm._v("Gell")]), _vm._v(", ed. J. C. Corson, 1957.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row21"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Gibson’s "), _c('i', [_vm._v("Reminiscences")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("John Gibson, "), _c('i', [_vm._v("Reminiscences of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1871.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row22"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Grierson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("H. J. C. Grierson, Sir Walter Scott, Bart., 1938.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row23"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Hall’s "), _c('i', [_vm._v("Fragments")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Basil Hall, "), _c('i', [_vm._v("Fragments of Voyages")]), _vm._v(", Third Series, 1840.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row24"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Haydon’s "), _c('i', [_vm._v("Diary")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Diary of B. R. Haydon")]), _vm._v(", ed. W. B. Pope, 1960.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row25"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Herd")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Ancient and Modern Scottish Songs")]), _vm._v(", ed. David Herd, 1791.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row26"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Jamieson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dr. John Jamieson, "), _c('i', [_vm._v("Etymological Dic")]), _c('i', [_vm._v("tionary of the Scottish Language")]), _vm._v(", new edition, 1879.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row27"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("J. G. L.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("John Gibson Lockhart.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row28"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Lady Shelley’s Diary ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Diary of Frances, Lady Shelley,")]), _vm._v(" "), _c('i', [_vm._v("1818–73")]), _vm._v(", ed. Richard Edgecumbe, 1912–13.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row29"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Letters ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Letters of Sir Walter Scott")]), _vm._v(", ed. H. J. C. Grierson and others, 12 vols., 1932–7.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row30"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Letters from Scott’s Family ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Letters from Members of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott’s Family")]), _vm._v(", ed. P. A. Wright- Henderson, 1905.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row31"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to and from Scott")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 5317.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row32"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to Laidlaw")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 860.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row33"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to Scott")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 869.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row34"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. G. Lockhart, "), _c('i', [_vm._v("Memoirs of the Life of")]), _vm._v(" "), _c('i', [_vm._v("Sir Walter Scott, Bart")]), _vm._v("., second edition, 1851.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row35"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life of Moscheles")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Charlotte Moscheles, "), _c('i', [_vm._v("The Life of")]), _vm._v(" "), _c('i', [_vm._v("Moscheles")]), _vm._v(", 1873.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row36"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life of Napoleon")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Sir Walter Scott, "), _c('i', [_vm._v("The Life of Napo")]), _c('i', [_vm._v("leon Buonaparte")]), _vm._v(", 1827.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row37"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Mackay’s "), _c('i', [_vm._v("Reminiscences")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("MacIntosh Mackay, "), _c('i', [_vm._v("Reminiscences")]), _vm._v(", no date.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row38"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Knighton")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Lady D. Knighton, "), _c('i', [_vm._v("Memoirs of Sir")]), _vm._v(" "), _c('i', [_vm._v("William Knighton")]), _vm._v(", 1838.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row39"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Mathews")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Mrs. Mathews, "), _c('i', [_vm._v("Memoirs of Charles")]), _vm._v(" "), _c('i', [_vm._v("Mathews")]), _vm._v(", 1839.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row40"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Moore ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memoirs of Thomas Moore")]), _vm._v(", ed. Lord John Russell, 1853.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row41"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Mrs. Hemans ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memoirs of Mrs. Hemans by her Sister")]), _vm._v(", 1839.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row42"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Misc. Prose Works ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Miscellaneous Prose Works of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1834–40.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row43"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Mrs. Davy’s Journal")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Mrs. Davy, ‘Extracts from a Family Journal’, Nat. Lib. Scot., MS. 3389.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row44"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Mrs. Hughes’s Recollections ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Letters and Recollections of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott by Mrs. Hughes")]), _vm._v(", ed. H. G. Hutchinson, 1904.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row45"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Nat. Lib. Scot.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The National Library of Scotland.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row46"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("O. E. D. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Oxford English Dictionary")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row47"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Omond")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("G. W. T. Omond, "), _c('i', [_vm._v("The Lord Advo")]), _c('i', [_vm._v("cates of Scotland")]), _vm._v(", 1883.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row48"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Partington’s "), _c('i', [_vm._v("Letter-Books ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Private Letter-Books of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott")]), _vm._v(", ed. Wilfred Partington, 1930.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row49"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("P. M. L. A. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Publications of the Modern Language")]), _vm._v(" "), _c('i', [_vm._v("Association")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row50"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Royal Society Minutes")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Royal Society Minute-Book, MS. in possession of the Royal Society of Edinburgh.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row51"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Sederunt Book")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Sederunt Book of the Trustees of James Ballantyne & Co., Nat. Lib. Scot., MSS 112–14.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row52"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Shortreed Papers")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 8993.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row53"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Skene’s Memories ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memories of Sir Walter Scott by James")]), _vm._v(" "), _c('i', [_vm._v("Skene")]), _vm._v(", ed. Basil Thomson, 1909.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row54"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("S. N. D. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Scottish National Dictionary")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row55"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Susan Frere")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Manuscript letters of Susan Frere, in the possession of Bartle Frere, Esq.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row56"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Tait")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Journal of Sir Walter Scott")]), _vm._v(", ed. J. G. Tait, 1939–46.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row57"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Ticknor’s Life")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("George S. Hillard, "), _c('i', [_vm._v("Life, Letters and")]), _vm._v(" "), _c('i', [_vm._v("Journals of George Ticknor")]), _vm._v(", 1876.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row58"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Walpole")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Walpole Collection, Nat. Lib. Scot., MSS 3901–19. (Unless otherwise stated, Walpole letters are addressed to Scott.)")])]), _vm._v(" "), _c('tr', {
    staticClass: "row59"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("W. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Writer to the Signet")])]), _vm._v(" "), _c('tr', {
    staticClass: "row60"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Youngson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("A. J. Youngson,"), _c('i', [_vm._v(" The Making of Clas")]), _c('i', [_vm._v("sical Edinburgh")]), _vm._v(", 1966.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row61"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row62"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110261-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22903cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_chapter_02.vue
// module id = 75
// module chunks = 0